// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"modal-take-payment_modalHeader__3dpug","modalBody":"modal-take-payment_modalBody__qTHLS"};